module.exports = __webpack_public_path__ + "img/lightGreyUserIcon.ce51fcc1.svg";